module.exports = __webpack_public_path__ + "static/media/citron-thumb.abe10739.jpg";